module.exports = __webpack_public_path__ + "static/media/man_caiming.330f9174.png";